import { utils } from '@didi/webx-js-core';
class LoadImgs extends utils.LoadImgs {
    constructor(imgs, opts) {
        super(imgs, opts);
    }
    loadImg(imgSrc) {
        return new Promise((resolve) => {
            setTimeout(() => {
                const imgObj = new Image();
                imgObj.onload = () => resolve(true);
                imgObj.onerror = () => resolve(false);
                imgObj.src = imgSrc;
            }, 0);
        });
    }
}
export default LoadImgs;
